import { Subscription } from '@models/subscription.model';
import { useTranslation } from '@testsigma/atoms';
import { TestCountWarpper } from './test-count-warpper';
import { LicenseUsageDetails } from '@modules/test-development/models/license-usage.model';

interface UsageCountPros {
  subscription: Subscription;
  licenseUsageDetails: LicenseUsageDetails;
}

export const UsageCount: React.FC<UsageCountPros> = ({
  subscription,
  licenseUsageDetails,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='flex py-5 gap-x-5'>
        <TestCountWarpper
          title={t('usage_details.paralle')}
          totalCount={subscription?.totalParallelRuns}
          countColor={'text-warning-500'}
          count={licenseUsageDetails?.usedParallelRuns}
        />

        <TestCountWarpper
          title={t('usage_details.queue')}
          totalCount={subscription?.allowedQueueSize || 0}
          count={licenseUsageDetails?.usedQueueSize}
        />

        {Boolean(subscription.additionalParallelRunsOnLocal) && (
          <TestCountWarpper
            title={t('usage_details.free_local')}
            totalCount={subscription?.additionalParallelRunsOnLocal || 0}
            count={licenseUsageDetails?.usedAdditionalParallelRunsOnLocal}
          />
        )}

        {Boolean(subscription.additionalParallelRunsOnCloud) && (
          <TestCountWarpper
            title={t('usage_details.free_cloud')}
            totalCount={subscription?.additionalParallelRunsOnCloud || 0}
            count={licenseUsageDetails?.usedAdditionalParallelRunsOnCloud}
          />
        )}

        {Boolean(subscription.freeLocalOnlyMobileSessions) && (
          <TestCountWarpper
            title={t('usage_details.free_mobile_session')}
            totalCount={subscription?.freeLocalOnlyMobileSessions}
            count={licenseUsageDetails?.usedFreeLocalOnlyMobileSessions}
          />
        )}
      </div>
    </>
  );
};
